import React, {useState} from 'react';
import StylesType from '@/types/StylesType';
import classnames from 'classnames';
import useSetHeight from '@/hooks/useSetHeight';
import {Resident} from '@/components';
import {useMount} from 'react-use';


interface ScrollView extends StylesType{
  backTop?: boolean,
  bottomHeight?: number,
}


const defaultStyles = {
  overflowY: 'scroll',
  paddingBottom: '40px'
}


const ScrollView: React.FC<ScrollView> = props => {
  
  const { style, className, children, bottomHeight, backTop} = props;
  const groupElementRef = useSetHeight(bottomHeight);
  
  let [target, setTarget] = useState();
  useMount(() => {
    if (groupElementRef.current) {
      // @ts-ignore
      setTarget(groupElementRef.current)
      
    }
  })
  
  return (
    <div ref={groupElementRef} style={Object.assign({}, defaultStyles, style)} className={classnames(className)}>
      {children}
      {backTop && target ? <Resident.BackTop target={() => target} /> : null}
    </div>
  )
  
}

ScrollView.defaultProps = {
  bottomHeight: 0,
  backTop: true
}

export default ScrollView;
